/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Box } from 'grommet';
import React from 'react';

import { navbarHeight } from 'blb-styles/constants';

export namespace NavBar {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const NavBar = (props: NavBar.Props): JSX.Element => (
  <Box
    align="center"
    background="white"
    direction="row"
    elevation="medium"
    height={navbarHeight}
    justify="between"
    pad={{ horizontal: 'medium', vertical: 'small' }}
    tag="header"
    {...props}
  />
);
